// removed by extract-text-webpack-plugin
module.exports = {"home":"_2D0a","rootContainer":"_1ntR","homeContainer":"_6PDq","container":"_2iwx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/homescreen/style.css
// module id = 398
// module chunks = 9